import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
  selector: 'cw-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @HostBinding('class') className = 'content-container';

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings/settings.component.ts